import {IomoPoleLuminaire} from './iomoPoleLuminaire';
import {IomoFloorLuminaire} from './iomoFloorLuminaire';
import {IomoCeilingLuminaire} from './iomoCeilingLuminaire';
import {IomoWallLuminaire} from './iomoWallLuminaire';

const iomoLuminaires = {
	pole: IomoPoleLuminaire,
	floor: IomoFloorLuminaire,
	ceiling: IomoCeilingLuminaire,
	wall: IomoWallLuminaire,
};


export {iomoLuminaires};
